module.exports = __webpack_public_path__ + "static/media/orgs_level.11022ccc.svg";